import * as actions from "../action.constants";

const initialState = {
  customFieldsData: {},
  customFieldChoicesData: {},
  customFieldChoicesLabelValue: [],
  fieldTypes: [],
  objectTypes: [],
  relatedObjectTypes: [],
};

const storeCustomFields = (state, action) => {
  return {
    ...state,
    customFieldsData: action.payload || {},
  };
};

const storeCustomFieldChoices = (state, action) => {
  return {
    ...state,
    customFieldChoicesData: action.payload || {},
  };
};

const storeObjectTypes = (state, action) => {
  return {
    ...state,
    objectTypes: action.payload || [],
  };
};

const storeRelatedObjectTypes = (state, action) => {
  return {
    ...state,
    relatedObjectTypes: action.payload || [],
  };
};

const storeFieldTypes = (state, action) => {
  return {
    ...state,
    fieldTypes: action.payload || [],
  };
};

const storeCustomFieldChoicesLabelValue = (state, action) => {
  return {
    ...state,
    customFieldChoicesLabelValue: action.payload || [],
  };
};

const handlers = {
  [actions.STORE_CUSTOM_FIELDS]: storeCustomFields,
  [actions.STORE_CUSTOM_FIELD_CHOICES]: storeCustomFieldChoices,
  [actions.STORE_OBJECT_TYPES]: storeObjectTypes,
  [actions.STORE_RELATED_OBJECT_TYPES]: storeRelatedObjectTypes,
  [actions.STORE_FIELD_TYPES]: storeFieldTypes,
  [actions.STORE_CUSTOM_FIELD_CHOICES_LABEL_VALUE]: storeCustomFieldChoicesLabelValue,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
